import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AnalyticsActions } from 'store/models/analytics'
import { WhyIntegrate } from './WhyIntegrate'
import { IntegrationStatus } from './IntegrationStatus'
import { Instructions } from './Instructions'
import styles from './Shopify.module.scss'

export const Shopify = () => {
    const dispatch = useDispatch()
    const [completedStep, setCompletedStep] = useState(localStorage.getItem('completedStep'))

    useEffect(() => {
        document.title = 'Shopify | Betterspace Supplier'
        dispatch(AnalyticsActions.postAnalytics('[Shopify] componentDidMount', null))
    }, [])

    return (
        <div className={styles.Shopify}>
            <h1>Integrate your Shopify account with Betterspace</h1>

            <div className={styles.row}>
                <WhyIntegrate />
                <IntegrationStatus {...{ completedStep }} />
            </div>
            <Instructions {...{ completedStep, setCompletedStep }} />
        </div>
    )
}
